import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import OTPInput from 'otp-input-react'
import Btn from 'components/Btn'
import { ArrowRight } from 'lucide-react'

export default withTranslation()(function EmailVerification({ t, email, onConfirm }) {
  const [otp, setOtp] = useState('')
  const [error, setError] = useState(false)
  const [resent, setResent] = useState(false)

  const confirm = () => {
    if (otp.length !== 6) {
      setError(true)
      return
    }
    setError(false)
    onConfirm()
  }

  const resend = () => {
    setOtp('')
    setError(false)
    setResent(true)
    setTimeout(() => setResent(false), 3000)
  }

  return (
    <div className="w-full text-center">
      <img src="/img/signup/mail.svg" alt="" className="w-16 h-16 mx-auto mb-6" />

      <h1 className="text-2xl font-bold text-black mb-1">{t('registration.email_verify.title')}</h1>
      <p className="text-secondary mb-8">
        {t('registration.email_verify.content')} <span className="font-semibold text-black">{email}</span>
      </p>

      <div className="relative flex justify-center mb-2">
        <OTPInput
          value={otp}
          onChange={setOtp}
          autoFocus
          OTPLength={6}
          otpType="number"
          disabled={false}
          className="gap-2 otp-group"
          inputClassName={`!w-11 !h-11 !rounded-lg !border ${error ? '!border-failure' : '!border-border-lines'} !text-black text-center font-semibold focus:!border-primary`}
        />
        <span className="absolute top-1/2 left-1/2 w-3 h-px -translate-x-1/2 -translate-y-1/2 bg-border-lines" />
      </div>

      {
        error && (
          <p className="text-failure text-sm font-medium mb-4">{t('registration.email_verify.error')}</p>
        )
      }

      <p className="text-secondary text-sm mb-8">
        {t('registration.email_verify.resend')}{' '}
        <button type="button" onClick={resend} className="text-primary font-medium">
          {resent ? '✓' : t('registration.email_verify.resend_cta')}
        </button>
      </p>

      <Btn
        content={() => <span className="flex items-center justify-center gap-2 text-white">{t('registration.email_verify.cta')} <ArrowRight size={16} /></span>}
        className="w-full h-12 rounded-full !bg-primary hover:!bg-primary"
        click={confirm}
      />
    </div>
  )
})
